// extracted by mini-css-extract-plugin
module.exports = {"SampleProperties":"style_SampleProperties__3c-td","title":"style_title__EPnma","properties":"style_properties__9nOrd"};